/**
 * AMAÇ: Frontend merkezi logger
 * Development'ta renkli console çıktısı verir
 * Production'da kritik hataları backend'e gönderir
 */

import { toGaEventName } from './googleAnalytics.js';

const isDev = import.meta.env.DEV;

const LEVELS = {
  debug: { color: '#94A3B8', label: 'DEBUG' },
  info:  { color: '#7DA8E8', label: 'INFO ' },
  warn:  { color: '#E0A93E', label: 'WARN ' },
  error: { color: '#E08585', label: 'ERROR' },
  action:{ color: '#9A8FE8', label: 'USER ' },
};

const log = (level, message, meta = {}) => {
  const { color, label } = LEVELS[level];
  const time = new Date().toLocaleTimeString('tr-TR');

  if (isDev) {
    console.log(
      `%c[${label}] %c${time} %c${message}`,
      `color:${color}; font-weight:bold`,
      'color:#94A3B8',
      'color:inherit',
      Object.keys(meta).length ? meta : ''
    );
  }

  // Production'da backend'e gönder (sadece warn ve error)
  if (!isDev && (level === 'error' || level === 'warn')) {
    sendToBackend({ level, message, meta, time });
  }

  // Kullanıcı aksiyonlarını GA4'e event olarak gönder (yalnızca event adı — meta/PII asla
  // gönderilmez). gtag yüklenmediyse (VITE_GA_MEASUREMENT_ID boşsa) no-op'tur.
  if (level === 'action' && typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', toGaEventName(message));
  }
};

const sendToBackend = async (payload) => {
  /**
   * AMAÇ: Frontend hatalarını backend log endpoint'ine iletir
   * Token varsa header'a ekler
   */
  try {
    const token = localStorage.getItem('streak_token');
    await fetch(`${import.meta.env.VITE_API_URL}/api/logs`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(payload),
    });
  } catch {
    // Log gönderme başarısızsa sessizce geç, uygulamayı etkileme
  }
};

const logger = {
  debug:  (msg, meta) => log('debug',  msg, meta),
  info:   (msg, meta) => log('info',   msg, meta),
  warn:   (msg, meta) => log('warn',   msg, meta),
  error:  (msg, meta) => log('error',  msg, meta),
  // Kullanıcı aksiyonlarını özel olarak logla
  action: (msg, meta) => log('action', msg, meta),
};

export default logger;
